const setShowEnterModalAction = ({ commit }, payload) => {
  commit("setShowEnterModal", payload);
};

const setHasPinAction = ({ commit }, payload) => {
  commit("setHasPin", payload);
};

const setRoomIdAction = ({ commit }, payload) => {
  commit("setRoomId", payload);
};

export default {
  setShowEnterModalAction,
  setHasPinAction,
  setRoomIdAction,
};
